import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrawer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"drawer-1"} maskId="square-filled-radius-0-stroke-1-IconDrawer1"><path fillRule="evenodd" clipRule="evenodd" d="M4 10.5V2H20V10.5H4ZM9 6H15V7H9V6Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M4 11.5V20H6.25V22H7.25V20H16.75V22H17.75V20H20V11.5H4ZM9 14.5V15.5H15V14.5H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDrawer1;
